import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import styles from '../../../styles/icons/base.module.scss';

const propTypes = {
    fill: PropTypes.string,
    stroke: PropTypes.string,
    className: PropTypes.string,
};

const defaultProps = {
    fill: 'currentColor',
    stroke: 'none',
    className: null,
};

const PauseIcon = ({ fill, stroke, className }) => (
    <svg
        width="16"
        height="22"
        viewBox="0 0 16 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={classNames([styles.container, { [className]: className !== null }])}
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M2.5 1.29541C1.67157 1.29541 1 1.96698 1 2.79541V19.7954C1 20.6238 1.67157 21.2954 2.5 21.2954H5.5C6.32843 21.2954 7 20.6238 7 19.7954V2.79541C7 1.96698 6.32843 1.29541 5.5 1.29541H2.5ZM10.5 1.29541C9.67157 1.29541 9 1.96698 9 2.79541V19.7954C9 20.6238 9.67157 21.2954 10.5 21.2954H13.5C14.3284 21.2954 15 20.6238 15 19.7954V2.79541C15 1.96698 14.3284 1.29541 13.5 1.29541H10.5Z"
            fill={fill}
        />
        <path
            d="M1.5 2.79541C1.5 2.24313 1.94772 1.79541 2.5 1.79541V0.79541C1.39543 0.79541 0.5 1.69084 0.5 2.79541H1.5ZM1.5 19.7954V2.79541H0.5V19.7954H1.5ZM2.5 20.7954C1.94772 20.7954 1.5 20.3477 1.5 19.7954H0.5C0.5 20.9 1.39543 21.7954 2.5 21.7954V20.7954ZM5.5 20.7954H2.5V21.7954H5.5V20.7954ZM6.5 19.7954C6.5 20.3477 6.05229 20.7954 5.5 20.7954V21.7954C6.60457 21.7954 7.5 20.9 7.5 19.7954H6.5ZM6.5 2.79541V19.7954H7.5V2.79541H6.5ZM5.5 1.79541C6.05228 1.79541 6.5 2.24313 6.5 2.79541H7.5C7.5 1.69084 6.60457 0.79541 5.5 0.79541V1.79541ZM2.5 1.79541H5.5V0.79541H2.5V1.79541ZM9.5 2.79541C9.5 2.24313 9.94771 1.79541 10.5 1.79541V0.79541C9.39543 0.79541 8.5 1.69084 8.5 2.79541H9.5ZM9.5 19.7954V2.79541H8.5V19.7954H9.5ZM10.5 20.7954C9.94771 20.7954 9.5 20.3477 9.5 19.7954H8.5C8.5 20.9 9.39543 21.7954 10.5 21.7954V20.7954ZM13.5 20.7954H10.5V21.7954H13.5V20.7954ZM14.5 19.7954C14.5 20.3477 14.0523 20.7954 13.5 20.7954V21.7954C14.6046 21.7954 15.5 20.9 15.5 19.7954H14.5ZM14.5 2.79541V19.7954H15.5V2.79541H14.5ZM13.5 1.79541C14.0523 1.79541 14.5 2.24313 14.5 2.79541H15.5C15.5 1.69084 14.6046 0.79541 13.5 0.79541V1.79541ZM10.5 1.79541H13.5V0.79541H10.5V1.79541Z"
            fill={stroke}
        />
    </svg>
);

PauseIcon.propTypes = propTypes;
PauseIcon.defaultProps = defaultProps;

export default PauseIcon;
